import { adminHttpClient } from '../../../commons/adminHttpClient'
import { EmployeeToInvite } from '../enums/employeeToInvite'

const inviteNonEligibleEmployee = (employee: EmployeeToInvite): Promise<any> => {
  return adminHttpClient.post('/InvitePeople/NonEligibleEmployee', employee)
}

export default inviteNonEligibleEmployee
